module.exports = __webpack_public_path__ + "img/masterCard.017feb9c.png";